import React from "react";
import "./Section.scss";
import { IBlockElement } from "../../../types/IBlockElement";

export default function Section({ id, className, children, onClick, onChange }: IBlockElement) {
    return <section id={id} className={className} onClick={onClick} onChange={onChange}>{children}</section>;
}